import { createContext, useState } from "react";
import { apiV1 } from "../lib/axios";
import { useAuth } from "../hooks/useAuth";
import { toast } from "react-toastify";
import { fileToBase64 } from "../utils/fileToBase64";

export const CompanyUserContext = createContext({});

export function CompanyUserProvider({ children }) {
  const [companyUsers, setCompanyUsers] = useState();
  const [selectedCompanyUser, setSelectedCompanyUser] = useState();
  const [loading, setLoading] = useState(false);

  async function listCompanyUser() {
    try{
      setLoading(true);
      const response = await apiV1.get("/company/user");
      
      setCompanyUsers(response.data.accesses);
    } catch (err) {
      console.log("err ", err);
      throw err;
    } finally {
      setLoading(false);
    }
  }

  async function editCompanyUser(data) {
    try{
      setLoading(true);
      await apiV1.patch("/company/user", data);
    } catch (err) {
      console.log("err ", err);
      throw err;
    } finally {
      setLoading(false);
    }
  }

  async function editCompanyUserStatus(data) {
    try{
      setLoading(true);
      await apiV1.patch("/company/user/block", data);
    } catch (err) {
      console.log("err ", err);
      throw err;
    } finally {
      setLoading(false);
    }
  }

  async function createCompanyUser(data) {
    try{
      setLoading(true);
      await apiV1.post("/company/user", data);
    } catch (err) {
      console.log("err ", err);
      throw err;
    } finally {
      setLoading(false);
    }
  }

  async function deleteCompanyUser() {
    try{
      setLoading(true);
      await apiV1.delete(`/company/user/${selectedCompanyUser.id}`);
    } catch (err) {
      console.log("err ", err);
      throw err;
    } finally {
      setLoading(false);
    }
  }

  return (
    <CompanyUserContext.Provider
      value={{
        companyUsers,
        setCompanyUsers,
        selectedCompanyUser,
        setSelectedCompanyUser,
        companyUserLoading: loading,
        setCompanyUserLoading: setLoading,

        listCompanyUser,
        createCompanyUser,
        editCompanyUser,
        editCompanyUserStatus,
        deleteCompanyUser
      }}
    >
      {children}
    </CompanyUserContext.Provider>
  );
}
